import {
  BRAND_NAME_FORMATTING,
  APPROVED_SUBSTITUTIONS,
  AVOID_CROSS_CATEGORY_COMPARISONS,
  APPROVED_NUTRIENT_RELATED_PHRASES,
  AVOID_SPECIFIC_CLAIM_LANGUAGE,
  APPROVED_ON_PACKAGE_LANGUAGE,
  APPROVED_QUALIFIER_PHRASES_BEFORE_CLAIMS,
  APPROVED_PRODUCT_ATTRIBUTE_AND_DISCLAIMER_TEXT,
  AVOID_RESTRICTED_TEXT_FOR_CLAIMS,
  Guideline
} from '../types/profileTypes';
import { useFormattedData } from './useFormattedData';

/**
 * Hook that returns default parameters for a given guideline type
 * @param type The guideline type (optional - if not provided, will use the type from the form)
 * @returns Default parameters for the given type
 */
export const useDefaultParameters = (type: string): Partial<Guideline> => {
  const brands = useFormattedData('brands');
  const defaultBrand = brands[0];

  if (!type) {
    return {
      name: '',
      type: undefined,
      parameters: {}
    };
  }

  switch (type) {
    case BRAND_NAME_FORMATTING:
      return {
        type: BRAND_NAME_FORMATTING,
        name: '',
        parameters: {
          format: 'with all capital letters',
          brandName: defaultBrand?.id || '',
          condition: 'always'
        }
      };
    case AVOID_CROSS_CATEGORY_COMPARISONS:
      return {
        type: AVOID_CROSS_CATEGORY_COMPARISONS,
        name: '',
        parameters: {
          comparisonType: 'category',
          target: ''
        }
      };
    case APPROVED_SUBSTITUTIONS:
      return {
        type: APPROVED_SUBSTITUTIONS,
        name: '',
        parameters: {
          restrictedTerm: '',
          approvedTerm: ''
        }
      };
    case APPROVED_NUTRIENT_RELATED_PHRASES:
      return {
        type: APPROVED_NUTRIENT_RELATED_PHRASES,
        name: '',
        parameters: {
          nutrient: '',
          nutrientStatement: '',
          amount: '',
          unit: 'Grams (g)'
        }
      };
    case AVOID_SPECIFIC_CLAIM_LANGUAGE:
      return {
        type: AVOID_SPECIFIC_CLAIM_LANGUAGE,
        name: '',
        parameters: {
          claimType: 'such as',
          topic: ''
        }
      };
    case APPROVED_ON_PACKAGE_LANGUAGE:
      return {
        type: APPROVED_ON_PACKAGE_LANGUAGE,
        name: '',
        parameters: {
          onPackageText: ''
        }
      };
    case APPROVED_QUALIFIER_PHRASES_BEFORE_CLAIMS:
      return {
        type: APPROVED_QUALIFIER_PHRASES_BEFORE_CLAIMS,
        name: '',
        parameters: {
          approvedPhrase: '',
          claim: ''
        }
      };
    case APPROVED_PRODUCT_ATTRIBUTE_AND_DISCLAIMER_TEXT:
      return {
        type: APPROVED_PRODUCT_ATTRIBUTE_AND_DISCLAIMER_TEXT,
        name: '',
        parameters: {
          productAttribute: '',
          approvedReplacement: '',
          restrictedText: '',
          disclaimer: ''
        }
      };
    case AVOID_RESTRICTED_TEXT_FOR_CLAIMS:
      return {
        type: AVOID_RESTRICTED_TEXT_FOR_CLAIMS,
        name: '',
        parameters: {
          topic: '',
          referenceText: ''
        }
      };
    default:
      return {
        name: '',
        type: undefined,
        parameters: {}
      };
  }
};
